import { defineMessages } from 'react-intl';

export default defineMessages({
    removeInfo: {
        id: 'quoteandbind.PSWLinedirectives.templates.Remove Massage Therapist',
        defaultMessage: 'Remove Massage Therapist',
    },
    removeInfoDesc: {
        id: 'quoteandbind.PSWLinedirectives.templates.MassageInfo',
        defaultMessage: 'Are you sure you want to remove this Massage Therapist from the list?',
    },
});